import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ onAddPrinter, hasFilters = false, onClearFilters }) => {
  if (hasFilters) {
    return (
      <div className="text-center py-12">
        <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="Search" size={32} className="text-muted-foreground" />
        </div>
        <h3 className="text-lg font-semibold text-foreground mb-2">
          Nenhuma impressora encontrada
        </h3>
        <p className="text-muted-foreground mb-6 max-w-md mx-auto">
          Não encontramos impressoras que correspondam aos filtros aplicados. 
          Tente ajustar os critérios de busca.
        </p>
        <Button
          variant="outline"
          iconName="X"
          iconPosition="left"
          onClick={onClearFilters}
        >
          Limpar Filtros
        </Button>
      </div>
    );
  }

  return (
    <div className="text-center py-16">
      <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-6">
        <Icon name="Printer" size={40} className="text-primary" />
      </div>
      <h3 className="text-xl font-semibold text-foreground mb-3">
        Nenhuma impressora cadastrada
      </h3>
      <p className="text-muted-foreground mb-8 max-w-md mx-auto">
        Comece adicionando sua primeira impressora 3D para gerenciar 
        seus projetos e acompanhar custos de impressão.
      </p>
      <Button
        iconName="Plus"
        iconPosition="left"
        onClick={onAddPrinter}
        className="hover-lift"
      >
        Adicionar Primeira Impressora
      </Button>
      
      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-2xl mx-auto text-left">
        <div className="flex items-start space-x-3">
          <div className="w-8 h-8 bg-success/10 rounded-lg flex items-center justify-center flex-shrink-0">
            <Icon name="BarChart3" size={16} className="text-success" />
          </div>
          <div>
            <h4 className="font-medium text-foreground mb-1">Controle de Custos</h4>
            <p className="text-sm text-muted-foreground">
              Acompanhe gastos com filamento e energia
            </p>
          </div>
        </div>
        
        <div className="flex items-start space-x-3">
          <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
            <Icon name="Clock" size={16} className="text-primary" />
          </div>
          <div>
            <h4 className="font-medium text-foreground mb-1">Histórico Completo</h4>
            <p className="text-sm text-muted-foreground">
              Registre todas as suas impressões
            </p>
          </div>
        </div>
        
        <div className="flex items-start space-x-3">
          <div className="w-8 h-8 bg-warning/10 rounded-lg flex items-center justify-center flex-shrink-0">
            <Icon name="Wrench" size={16} className="text-warning" />
          </div>
          <div>
            <h4 className="font-medium text-foreground mb-1">Manutenção</h4>
            <p className="text-sm text-muted-foreground">
              Lembretes de cuidados preventivos
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyState;